var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"form-sale-page"}},[_c('SaleForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }